import * as React from "react";
import { TableRow } from "../table/table-row/table-row.mjs";
import { TableCell } from "../table/table-cell/table-cell.mjs";
const PacketsTableHeader = (props) => {
  const { packets } = props;
  return /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, { type: "th", width: 3, scope: "col", background: "neutral-bg-level-2" }), packets.map((packet, index) => /* @__PURE__ */ React.createElement(TableCell, { key: "".concat(packet.name, "-table-header-").concat(index), type: "th", scope: "col", width: 2, className: "text-center", background: "neutral-bg-level-2" }, /* @__PURE__ */ React.createElement("p", { className: "h5" }, packet.name)))));
};
export {
  PacketsTableHeader
};
